export class PedidoExtracaoRequest {
  /**
   * Identificador do tipo de extração que será realizada.
   */
  idTipoExtracao: number; // int

  /**
   * String JSON contendo os filtros específicos para a extração.
   */
  jsonFiltros?: string | null;

  /**
   * Origem (tela/funcionalidade) do pedido de exportação (int, valores de OrigemPedidoExportacaoEnum),
   * usada para validar a permissão de exportação.
   */
  origemPedidoExportacao: number; // int
}